export default "__VITE_ASSET__nwYZEsrv__"